// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hhMk","field":"styles_field__278lq","fieldCol":"styles_fieldCol__2R6wE","diffCol":"styles_diffCol__gXM-P","diff":"styles_diff__y8cC6"};